import { render, staticRenderFns } from "./DomainDetails.vue?vue&type=template&id=0a6ae834&"
import script from "./DomainDetails.vue?vue&type=script&lang=ts&"
export * from "./DomainDetails.vue?vue&type=script&lang=ts&"
import style0 from "./DomainDetails.vue?vue&type=style&index=0&id=0a6ae834&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports